import { General } from "../../../siteManagement/general.js";
import { Sheet } from "../../../siteManagement/sheet.js";
import { Config } from "../config/config.js";
import React from "react";
export class ConnectedWindow extends React.Component<{ parent, parentSheet?: Sheet, openAsPopUp: boolean, moduleName: string, className: string, onClose?: () => void }, { enabled: boolean, interop?: any }> {
    private windowRef: WindowProxy;

    constructor(props) {
        super(props);
        this.state = { enabled: true };
    }

    private waitUntilLoaded = () => {
        const interopInterval = setInterval(() => {
            const gridInteropObject = this.windowRef["__globalWorkListGridInterop"];
            if (gridInteropObject) {
                gridInteropObject.render(this.props.parent, true);
                this.setState({ interop: gridInteropObject });
                clearInterval(interopInterval);
            }
        }, 200);
    }

    private checkSheetOverlapOrIsClosed = () => {
        const interval = setInterval(() => {
            if (this.state.interop || this.windowRef.closed) {
                if (this.props.parentSheet) {
                    let newEnabled = General.Sheet.Manager.getTopMostVisibleSheet() == this.props.parentSheet;
                    if (this.state.enabled != newEnabled) {
                        this.setState({ enabled: newEnabled });
                    }
                }

                let shouldClose = false;
                try {
                    if (!this.windowRef["__globalWorkListGridInterop_connected"]) {
                        shouldClose = true;
                    }
                } catch (e) {
                    shouldClose = true;
                }
                if (this.windowRef.closed) {
                    shouldClose = true;
                }
                if (shouldClose) {
                    this.windowRef.close();
                    clearInterval(interval);
                    this.props.onClose && this.props.onClose();
                }
            }
        }, 50);

        window.addEventListener('beforeunload', (event) => {
            this.windowRef.close();
        });
    }

    componentDidMount() {
        setTimeout(() => {//SetTimeout wird benötigt, da es sonst zu Fehlern im Firefox kommt
            this.windowRef = window.open(Config.baseUrl + `FSMPart/ShowInWindow?moduleName=${this.props.moduleName}&className=${this.props.className}`, '', `width=800,popup=${this.props.openAsPopUp ? 'yes' : 'no'},height=${screen.height}`);
            this.waitUntilLoaded();
            this.checkSheetOverlapOrIsClosed();
        }, 100);
    }

    componentDidUpdate() {
        if (this.state.interop) {
            this.state.interop.render(this.props.parent, this.state.enabled);
        }
    }

    componentWillUnmount() {
        this.windowRef.close();
    }
    render() {
        return null;
    }
}